import DriverCertificationsModal from './DriverCertificationsModal';
import TruckPermitRuleModal from './TruckPermitRuleModal';
import TruckInspectionModal from './TruckInspectionModal';
import FuelInfoModal from './FuelInfoModal';
import TruckModelModal from './TruckModelModal';
import LienHolderModal from './LienHolderModal';
import RentalCompanyModal from './RentalCompanyModal';

export {
  DriverCertificationsModal,
  TruckPermitRuleModal,
  TruckInspectionModal,
  FuelInfoModal,
  TruckModelModal,
  LienHolderModal,
  RentalCompanyModal,
};

export const safetyModals = {
  DRIVER_CERTIFICATIONS_MODAL: DriverCertificationsModal,
  TRUCK_INSPECTIONS_MODAL: TruckInspectionModal,
  DRIVER_SAFETYINFO_MODAL: FuelInfoModal,
  TRUCK_MODEL_MODAL: TruckModelModal,
  LIEN_HOLDER_MODAL: LienHolderModal,
  TRUCK_PERMIT_RULE_MODAL: TruckPermitRuleModal,
  RENTAL_COMPANY_MODAL: RentalCompanyModal,
};
